

function validateResponse(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export function loadCsrf(setCsrfStateCallback) {
    return fetch(process.env.REACT_APP_HOST_API_URL + '/developer/mvc/api/csrf', {
      headers: {
        'Accept': 'application/json',
        },
        credentials: 'include'
        })
        .then(results=> {
            validateResponse(results);
            return results.json();
        })
        .then(data => {
            setCsrfStateCallback(data.token, data.headerName);
            return data;
        })
        .catch(error => {
            console.log('error trying to fetch csrf : \n', error);
            return Promise.reject(error);
        })

  }



// WEBPACK FOOTER //
// ./src/common/CsrfFetcher.js